import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { useBreakpoint } from '../../hooks/useBreakpoint';
import ImageWithZoom from './ImageWithZoom';
import Modal from 'react-modal';
import Icon from '../../common/components/Icon';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export interface ImageGalleryProps {
  images: { url: string; alt?: string }[];
}

const ImageGallery: React.FC<ImageGalleryProps> = ({ images }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState<number>(0);
  const { isExtraSmall, isSmall, isMedium } = useBreakpoint();
  const isMobile = isExtraSmall || isSmall || isMedium;

  const openModal = (index: number) => {
    setSelectedImageIndex(index);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <div>
      <div className="ecom-gallery">
        {!isMobile ? (
          images?.map((image, index) => (
            <ImageWithZoom {...image} key={index} onClick={() => openModal(index)} index={index} />
          ))
        ) : (
          <Swiper slidesPerView={1.15} spaceBetween={2} className="image-gallery-swiper" loop>
            {images?.map((image, index) => (
              <SwiperSlide key={index}>
                <ImageWithZoom {...image} key={index} onClick={() => openModal(index)} index={index} />
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>

      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        contentLabel="Image Viewer"
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            padding: isMobile ? '1.5rem' : '4rem',
          },
        }}
        overlayClassName="ecom-image-gallery-modal"
      >
        <Swiper
          initialSlide={selectedImageIndex}
          spaceBetween={30}
          slidesPerView={1}
          navigation={true}
          modules={[Navigation]}
          loop
        >
          {images?.map((image, index) => (
            <SwiperSlide key={index}>
              <img key={index} src={image.url} alt={image.alt} />
            </SwiperSlide>
          ))}
        </Swiper>
        <button onClick={closeModal} className="ecom-gallery__close">
          <Icon name="close" />
        </button>
      </Modal>
    </div>
  );
};

export default ImageGallery;
